import 'vuetify/styles'
import { ru } from 'vuetify/locale'
import '@mdi/font/css/materialdesignicons.css'
import '@vuepic/vue-datepicker/dist/main.css'
import { createVuetify } from 'vuetify'
import components from './usedComponents'
import directives from './usedDirectives'
import defaults from './defaults'
import theme from './theme'
import icons from './icons'
import { App } from 'vue'

const vuetify = createVuetify({
  components,
  directives,
  locale: {
    locale: 'ru',
    messages: { ru },
  },
  icons,
  defaults,
  theme,
})

export function registerVuetify(app: App<Element>) {
  app.use(vuetify)
}
